import { Flex } from "@mantine/core";
import InfoBox from "./InfoBox";
import { useEffect, useState } from "react";
import {
  getLiveAverageWork,
  getLiveOvertimeCount,
  getLiveTotalEmployee,
  getLiveTotalTodayEmployee,
} from "../../api/dashboardApi";
import {
  UsersIcon,
  IdentificationIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import SvgIcon from "../common/Icons/SvgIcon";
import { theme } from "../../theme";
import { ReactComponent as Icon } from "../../assets/clockError.svg";
import { useFilterContext } from "../../context/DashboardFilterContext";

const InfoBoxes = ({ flex }: { flex: any }) => {
  const { filters } = useFilterContext();
  const [totalEmployeeData, setTotalEmployeeData] = useState<any>();
  const [averageWorkData, setAverageWorkData] = useState<any>();
  const [overtimeCountData, setOvertimeCountData] = useState<any>();
  const [totalTodayEmployeeData, setTotalTodayEmployeeData] = useState<any>();

  const getTotalEmployee = async () => {
    try {
      const response = await getLiveTotalEmployee(filters);
      if (response?.success) {
        setTotalEmployeeData(response?.data);
      }
    } catch (error) {}
  };

  const getAverageWork = async () => {
    try {
      const response = await getLiveAverageWork(filters);

      if (response?.success) {
        setAverageWorkData(response?.data);
      }
    } catch (error) {}
  };

  const getOvertimeCount = async () => {
    try {
      const response = await getLiveOvertimeCount(filters);
      if (response?.success) {
        setOvertimeCountData(response?.data);
      }
    } catch (error) {}
  };

  const getTotalTodayEmployee = async () => {
    try {
      const response = await getLiveTotalTodayEmployee(filters);
      if (response?.success) {
        setTotalTodayEmployeeData(response?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getTotalEmployee();
    getAverageWork();
    getOvertimeCount();
    getTotalTodayEmployee();
  }, [filters]);
  return (
    <Flex gap={20} direction={"column"} flex={flex}>
      <Flex flex={1} gap={20}>
        <InfoBox
          title="Toplam Çalışan"
          Icon={<UsersIcon color={theme.colors.brand.normal} height={14} />}
          flex={1}
          data={totalEmployeeData}
        />
        <InfoBox
          title="Bugün Aktif"
          Icon={
            <IdentificationIcon color={theme.colors.brand.normal} height={14} />
          }
          data={totalTodayEmployeeData}
          flex={1}
        />
      </Flex>
      <Flex flex={1} gap={20}>
        <InfoBox
          title="Ortalama Çalışma"
          Icon={<ClockIcon color={theme.colors.brand.normal} height={14} />}
          data={averageWorkData}
          flex={1}
        />
        <InfoBox
          title="Fazla Mesai"
          Icon={
            <SvgIcon color={theme.colors.brand.normal} Icon={Icon} width={14} />
          }
          data={overtimeCountData}
          flex={1}
        />
      </Flex>
    </Flex>
  );
};

export default InfoBoxes;
